<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar title="交易汇总" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
    <!--导航栏 end-->

    <!--内容 start-->
    <div class="page">
      <div class="list">
        <!-- 交易汇总 -->
        <div class="list-top">
          <!-- 选择门店 -->
          <div>
            <van-dropdown-menu>
              <van-dropdown-item ref="item" :title="store_name">
                <van-cell @click="outlet('', '全部门店')" title="全部门店" is-link />
                <div v-for="(bububu, index) in option1" :key="index">
                  <van-cell @click="outlet(bububu.id, bububu.store_name)" :title="bububu.store_name" is-link />
                </div>
              </van-dropdown-item>
            </van-dropdown-menu>
          </div>
          <!-- 日周月报表 -->
          <div class="report-type">
            <div :class="forms == 'day' ? 'active-report' : ''" @click="reportHandel('day')">日报表</div>
            <div :class="forms == 'week' ? 'active-report' : ''" @click="reportHandel('week')">周报表</div>
            <div :class="forms == 'month' ? 'active-report' : ''" @click="reportHandel('month')">月报表</div>
          </div>
        </div>
      </div>

      <div class="list-data">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="10">
          <div v-for="(admin, index) in list" :key="index">
            <van-grid :column-num="3" :border="false">
              <van-grid-item :text="admin.date" />
              <van-grid-item :text="admin.summary_collest_count + '笔'" />
              <van-grid-item :text="admin.summary_collest + '元'" />
            </van-grid>
          </div>
        </van-list>
      </div>
    </div>
    <!--内容 end-->
  </div>
</template>

<script>
// import {Toast} from 'vant';

export default {
  name: "MerchantInformation", //交易汇总
  data() {
    return {
      forms: "day", //默认日报表 
      list: [],
      option1: [],
      store_id: "",
      store_name: "",
      loading: false,
      finished: false,
      page: 0,
      num: 20,
    };
  },
  methods: {
    //点击报表类型
    reportHandel(active) {
      this.forms = active
      this.page = 0
      this.list = []
      this.onLoad()
    },

    // 左侧返回
    onClickLeft() {
      this.$router.push("/MerchantHomepage");
    },

     //初始化时默认是日报表
     daily() {
            this.forms = "day"
        },

    //全部门店列表
    theStores() {
      this.$http
        .get("/wechat/user/get_merchant_list", {
          params: {
            merchant_id: window.sessionStorage.getItem("commercialId"),
          },
        })
        .then((response) => {
          this.option1 = response.data.data;
          this.number();
          this.page = 0;
          this.list = [];
          this.onLoad();
        });
    },
    //默认选择全部门店
    number() {
      if (this.store_id == "") {
        this.store_id = "";
        this.store_name = "全部门店";
      }
    },
    //门店选择
    outlet(a, b) {
      this.store_id = a;
      this.store_name = b;
      this.$refs.item.toggle();
      //    this.choose()
      this.page = 0;
      this.list = [];
      this.onLoad();
    },

    // 触发下拉刷新更多
    onLoad() {
      this.page += 1;
      this.report();
    },
    //报表
    report() {
      var that = this;
      // console.log(this.page);
      let params = {};
      params.page = this.page;
      params.num = this.num;
      params.merchant_id = window.sessionStorage.getItem("commercialId");
      params.summary_type = this.forms;
      params.store_id = this.store_id;
      console.log(params);
      this.$http
        .post("/wechat/api.order/get_order_summary", params)
        .then((response) => {
          console.log(response.data.data.length);
          // this.list=response.data.data
          this.loading = false;
          that.list.push(...response.data.data);
          console.log(that.list);
          if (response.data.data.length < this.num) {
            this.finished = true;
            return;
          }
          // console.log(this.list);
          // if (response.data.data.length) {
          //   that.list.push(...response.data.data);
          //   // console.log("哈哈哈哈哈",response.data.data.length)
          //   if(response.data.data.length<10){
          //     that.finished = true;
          //   }
          // }
        });
    },
  },
  mounted() {
    this.daily()
    this.theStores();
  },
};
</script>

<style scoped lang="less">
.active-report {
  font-weight: 700;
  color: rgb(20, 134, 251);
}

.page {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  padding: 16px;
  background-color: rgba(20, 134, 251, 1);
}

.list {
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  height: 40px;
  margin-top: 50px;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-radius: 12px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom: 1px solid rgba(215, 215, 215, 1);
}

.list-top {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #333333;
}

.list-data {
  width: 100%;
  height: calc(100vh - 200px);
  overflow-y: auto;
  background-color: #fff;
}

.report-type {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #333333;
}

.list-top /deep/ .van-dropdown-menu__bar {
  box-shadow: none !important;
  height: 30px !important;
}

.list-top /deep/ .van-dropdown-menu__title {
  font-size: 12px;
  color: #333333;
  max-width: none;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#vat_tabs {
  font-size: 0.6rem;
  /* border: solid 2px red; */
}

#vat_grid {
  position: relative;
  bottom: 0.1rem;
}

.main {
  /* position: sticky;
    top: 1.22rem; */
  z-index: 1000;
  position: relative;
}

.main-div {
  position: fixed;
  top: 0;
  width: 100%;
}

.content {
  margin-top: 4.8rem;
  /* border: solid 1px red; */
}

::v-deep .van-popup {
  overflow-y: auto !important;
}

.van_tabs {
  /* border: solid 1px red; */
  position: relative;
  bottom: 0.1rem;
}
</style>
